import { VisionApplication } from '../../application';
import { VisionMap } from '../../map/map';
import { VisionCameraTab } from './camera';

/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
export class VisionCameraMap {
    parent: VisionCameraTab;
    map!: VisionMap;

    constructor(parent: VisionCameraTab) {
        this.parent = parent;

        this.parent.layout.cells('b').attachHTMLString('<div id="camera_map_id" style="width:100%;height:100%"></div>');
        //this.parent.layout.cells('b').setText("Grading Map");
        //this.parent.layout.cells('b').attachHTMLString('<div id="grading_map_id" style="width:100%;height:100%"></div>');

        this.map = new VisionMap('camera_map_id');
        this.map.init('camera_map', this.parent.app.organizationService.dto?.latitude, this.parent.app.organizationService.dto?.longitude).then(() => {
            console.log('Camera Map Initialized');
            VisionApplication.getInstance().setMapWorkspace(this.map.map);
            this.parent.afterMapInit();
        });
    }
}
